export default __webpack_public_path__ + "static/media/save-earth.b3acd4ba.png";